import { useCallback, useState } from 'react';

type UseUnsavedChangesGuardParams = {
    readonly hasUnsavedChanges: boolean;
};

type UseUnsavedChangesGuardResult = {
    readonly cancelDiscard: () => void;
    readonly confirmDiscard: () => void;
    readonly isDiscardDialogOpen: boolean;
    readonly requestDiscard: (proceed: () => void) => void;
};

export const useUnsavedChangesGuard = ({
    hasUnsavedChanges,
}: UseUnsavedChangesGuardParams): UseUnsavedChangesGuardResult => {
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

    const requestDiscard = useCallback(
        (proceed: () => void) => {
            if (hasUnsavedChanges) {
                setPendingAction(() => proceed);
            } else {
                proceed();
            }
        },
        [hasUnsavedChanges],
    );

    const confirmDiscard = useCallback(() => {
        pendingAction?.();
        setPendingAction(null);
    }, [pendingAction]);

    const cancelDiscard = useCallback(() => {
        setPendingAction(null);
    }, []);

    return {
        cancelDiscard,
        confirmDiscard,
        isDiscardDialogOpen: pendingAction !== null,
        requestDiscard,
    };
};
